/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import AppText from "../other/AppText";
import { AppIconButton } from "../buttons/AppIconButton";
import { ChevronRight } from "lucide-react";

const LocationCard = ({ item, moreDetails }: { item: any; moreDetails: string }) => {
  const cardText = item?.blocks?.[1]?.fields?.cardTexts;
  const cardTextArr = cardText?.find((arr: { key: string }) => arr.key === "Address");
  const address = cardTextArr?.value;
  const _stateSlug = item.stateSlug ? item.stateSlug : (item.state || "").replaceAll(" ", "-").toLowerCase();

  return (
    <div key={item.id} className="flex flex-col min-w-[242px]">
      <AppText type="TITLE_SMALL" className="leading-0 text-ellipsis mb-1">
        {item.name}
      </AppText>
      <AppText type="BODY_SMALL" className="leading-0 text-ellipsis">
        {item.phone}
      </AppText>
      <AppText type="BODY_SMALL" className="leading-0 text-ellipsis">
        {address}
      </AppText>
      <AppText type="BODY_SMALL" className="leading-0 text-ellipsis mb-4">
        {`${item.state} ${item.zipCode}`}
      </AppText>

      <AppIconButton
        intent="ghost"
        label={moreDetails}
        link={`/locations/${_stateSlug}/${item.slug}`}
        icon={<ChevronRight size={20} aria-label="chevron right icon" />}
        iconOnRightSide
        className="after:left-0 after:right-0 pl-0"
      />
    </div>
  );
};

export default LocationCard;
